const cache = Object.create(null);

export default function fetchJSON(url) {
  if (url in cache) {
    return cache[url];
  }

  const request = fetch(url).then(res => res.json());
  cache[url] = request;

  return request;
}



// WEBPACK FOOTER //
// ./utils/fetch-json.js